module.exports = __webpack_public_path__ + "media/icons/white-document-f6a848fd.png";